<template>
  <transition name="fade-transform" mode="out-in">
    <keep-alive :include="cachedViews">
      <router-view :key="key" class="layout-container" :class="containerHeight"/>
    </keep-alive>
  </transition>
</template>

<script>
import {mapState} from "vuex";

export default {
  name: 'AppMain',
  computed: {
    ...mapState({
      showBreadcrumb: state => state.app.showBreadcrumb,
    }),
    cachedViews() {
      // ['Home','User']组件名称
      // console.log("=========cachedViews======>", this.$store.state.tabsView.cachedViews)
      return this.$store.state.tabsView.cachedViews
    },
    key() {
      return this.$route.fullPath
    },
    containerHeight() {
      return this.showBreadcrumb ? 'calcHeight-width-breadcrumb' : 'calcHeight-no-breadcrumb'
    }
  }
}
</script>

<style lang="less">
.calcHeight-width-breadcrumb {
  height: calc(100vh - 50px - 40px) !important;
}

.calcHeight-no-breadcrumb {
  height: calc(100vh - 50px) !important;
}

.app-main {
  width: 100%;
  margin: 0;
  box-sizing: border-box;
  position: relative;
  overflow: auto;
}

.layout-container {
  font-size: 14px;
  height: 100%;
  position: relative;
  box-sizing: border-box;
  overflow: auto;

  .header {
    margin-bottom: 10px !important;
    .layout-search {
      margin-bottom: 0 !important;
    }
  }

  .layout-search {
    width: 100%;
    padding: 10px 10px;
    background-color: #FFFFFF;
    margin-bottom: 10px;
  }

  .layout-function {
    width: 100%;
    padding: 10px 10px;
    display: flex;
    justify-items: center;
    background-color: #FFFFFF;

  }

  .layout-result {
    //flex: 1;
    width: 100%;
    padding: 10px 10px;
    background-color: #FFFFFF;
    box-sizing: border-box;
    // =========（S）=========
    // 核心问题，解决list页面的固定高度，且页面撑满布局
    display: flex;
    flex-direction: column;
    // 核心问题，解决list页面的固定高度，且页面撑满布局
    // =========（E）=========
  }
}

.layout-function,
.layout-search {
  .el-form-item {
    margin-bottom: 0 !important;
  }
}

.el-dialog {
  .el-container {
    .layout-main {
      .layout-result{
        display: block;
      }
    }
  }
}
</style>
